/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Exclude_FsInputs */



/**
* | output |
* | --- |
* | "Exclude FS" |
*
* @param {Subtitle_Export_Exclude_FsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_exclude_fs = /** @type {((inputs?: Subtitle_Export_Exclude_FsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Exclude_FsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exclure FS")
	if (locale === "de") return /** @type {LocalizedString} */ ("FS ausschließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Escludi FS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исключить FS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Excluir FS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("排除 FS")
	if (locale === "ja") return /** @type {LocalizedString} */ ("FSを除外")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एफएस को बाहर रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir FS")
	return /** @type {LocalizedString} */ ("Exclude FS")
});